module.exports = __webpack_public_path__ + "static/img/060.be86c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/060.png
// module id = NHI4
// module chunks = 0